import sds from 'utils/sds';

const seismicBaseQueryKey = 'seismicBaseQuery';
const iframedInSeismicBaseKey = 'iframedInSeismicBase';
const iframedInSeismicBaseExpectedValue = 'true';

let seismicDomain;
let originalUrl;

class LinkWrapper {
  constructor(element) {
    this.link = this.getClosestLink(element);
  }

  unifiable = () =>
    this.link !== null &&
    this.getPath() !== null &&
    this.link.getAttribute('unified') !== 'false';

  modify = () => {
    const unifiedUrl = this.createUnifiedUrl();
    originalUrl = this.link.href;
    this.link.href = unifiedUrl;

    const that = this;
    setTimeout(() => {
      if (originalUrl) {
        that.link.href = originalUrl;
        originalUrl = null;
      }
    }, 100);
  };

  addLearningUrlParam = () => {
    const url = new URL(this.link.href);
    const params = new URLSearchParams(url.search);
    if (!params.has('learningApp')) {
      if (!originalUrl) {
        originalUrl = this.link.href;
      }
      const separator = this.getPath().includes('?') ? '&' : '?';
      this.link.href += `${separator}learningApp=true`;

      const that = this;
      setTimeout(() => {
        if (originalUrl) {
          that.link.href = originalUrl;
          originalUrl = null;
        }
      }, 100);
    }
  };

  createUnifiedUrl = () => {
    return this.seismicBaseUrlPrefix() + this.getPath();
  };

  getPath = () => {
    if (this.path) {
      return this.path;
    }

    let url = this.link.href;
    let path = null;
    try {
      url = new URL(url);
      // only change urls of the same origin
      if (window.location.origin === url.origin) {
        path = url.pathname + url.search + url.hash;
      }
    } catch {
      // ignore
    }

    this.path = path;
    return path;
  };

  getClosestLink = element => {
    while (element && element !== null && element.tagName !== 'A') {
      element = element.parentNode;
    }

    return element || null;
  };

  isPopUp = () => !['_self', ''].includes(this.link.target);

  seismicBaseUrlPrefix = () => {
    const baseQuery = sessionStorage.getItem(seismicBaseQueryKey) || '';
    return `https://${seismicDomain}/app${baseQuery}#/learning`;
  };
}

const resolveSeismicDomain = async () => {
  if (!seismicDomain) {
    // eslint-disable-next-line no-underscore-dangle
    const tenant = global.__LLY_TENANT__.name || global.__LLY_TENANT__.id;
    try {
      seismicDomain = await sds.getSeismicDomain(tenant);
    } catch {
      console.warn(`Learning: Unable to fetch tenant info for ${tenant}`);
    }
  }
};

const modifierAction = e => e.shiftKey || e.ctrlKey || e.altKey || e.metaKey;

const linkModificationListeners = () => {
  window.addEventListener('click', async e => {
    await resolveSeismicDomain();
    if (seismicDomain) {
      const link = new LinkWrapper(e.target);
      if (link.unifiable() && (modifierAction(e) || link.isPopUp())) {
        link.modify();
      }
      if (link.link.href) {
        link.addLearningUrlParam();
      }
    }
  });

  window.addEventListener('contextmenu', async e => {
    await resolveSeismicDomain();
    if (seismicDomain) {
      const link = new LinkWrapper(e.target);
      if (link.unifiable()) {
        link.modify();
      }
    }
  });
};

const storageChangeHandler = event => {
  if (
    event.storageArea === sessionStorage &&
    event.key === iframedInSeismicBaseKey
  ) {
    if (event.newValue === iframedInSeismicBaseExpectedValue) {
      linkModificationListeners();
    }
    window.removeEventListener('storage', storageChangeHandler);
  }
};

window.addEventListener('DOMContentLoaded', async event => {
  if (
    // eslint-disable-next-line no-underscore-dangle
    global.__LLY_TENANT__ &&
    window.location !== window.parent.location
  ) {
    await resolveSeismicDomain();

    if (
      sessionStorage.getItem(iframedInSeismicBaseKey) ===
      iframedInSeismicBaseExpectedValue
    ) {
      linkModificationListeners();
    } else {
      window.addEventListener('storage', storageChangeHandler);
    }
  }
});
